import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";

export default LabelProvider.create({

	OrganizationEmpty: {
		k: "organization.missing.title",
		v: "No Organization Selected"
    },
    DescriptionEmpty:{
        k:"organization.missing.description",
        v:"Please select an organization to see the user list."
    },
    ...Messages,
    ...filters
});



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/BundleEntryList.labels.ts